import { css } from "@emotion/css";
import { Button, Callout } from "@octopusdeploy/design-system-components";
import { space, themeTokens } from "@octopusdeploy/design-system-tokens";
import * as React from "react";
import semver from "semver/preload";
interface NewProcessTemplateVersionCalloutProps {
    onUpdateToLatest: () => void;
    onDismiss?: () => void;
    isDismissed: boolean;
    currentVersion: string | undefined;
    latestStableVersion: string | undefined | null;
}
export function UpdateProcessTemplateVersionCallout({ onUpdateToLatest, isDismissed, currentVersion, latestStableVersion, onDismiss }: NewProcessTemplateVersionCalloutProps) {
    const isCurrentVersionOlderThanLatest = currentVersion && latestStableVersion ? semver.ltr(currentVersion, latestStableVersion) : false;
    const displayCallout = isCurrentVersionOlderThanLatest && !isDismissed;
    if (displayCallout) {
        return (<Callout type={"warning"} title={`Version ${latestStableVersion} of this template is available. You are currently using Version ${currentVersion}.`} canClose={true} onClose={onDismiss}>
                <div className={versionCalloutStyles.descriptionContainer}>
                    These areas may have changed:{" "}
                    <ul className={versionCalloutStyles.list}>
                        <li>Parameters</li>
                        <li>Steps added or removed</li>
                    </ul>
                    We recommend updating the template once you've reviewed these changes.
                </div>
                <Button importance={"primary"} label={"Update to new template"} onClick={onUpdateToLatest}/>
            </Callout>);
    }
    return null;
}
const versionCalloutStyles = {
    descriptionContainer: css({
        marginBottom: space[12],
        color: themeTokens.color.callout.text.warning,
    }),
    list: css({
        marginTop: 0,
        listStylePosition: "inside",
        listStyleType: "disc",
        color: themeTokens.color.callout.text.warning,
    }),
};
